import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import MuiDrawer from "@mui/material/Drawer";
import { CSSObject, styled, Theme } from "@mui/material/styles";

import { CustomStyle } from "../../GlobalTypes";

//constant for the width of the drawer
export const drawerWidth: number = 240;

//style for the opened drawer
const openedMixin: (theme: Theme) => CSSObject = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  backgroundColor: "rgb(14, 31, 66)",
});

//style for the closed drawer
const closedMixin: (theme: Theme) => CSSObject = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  backgroundColor: "rgb(14, 31, 66)",
});

export const DrawerHeader = styled("div")(({ theme }: { theme: Theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export const DrawerBase = styled(MuiDrawer, { shouldForwardProp: (prop: string) => prop !== "open" })(
  ({ theme, open }: { theme: Theme; open?: boolean }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme),
    }),
  }),
);

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop: string) => prop !== "open",
})<AppBarProps>(({ theme, open }: { theme: Theme; open?: boolean }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const DrawerStyle: CustomStyle = {
  toolbar: {
    justifyContent: "space-between",
  },
  toolbarBox: {
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",
  },
  switchBox: {
    display: "flex",
    alignItems: "center",
    paddingRight: 32,
  },
  blockDisplay: {
    display: "block",
  },
  whiteColor: {
    color: "white",
  },
  transparentColor: {
    color: "transparent",
  },
  transparentBorderColor: {
    borderColor: "transparent",
  },
  lightBorderColor: {
    borderColor: "rgba(255, 255, 255, 0.12)",
  },
  username: {
    padding: 8,
    fontSize: 28,
    color: "white",
  },
};
